import React, { lazy, Suspense } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';

const LoadableProgressPopup = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "mainimagepopup" */
        './ProgressPopup'
      )
  )
);

interface Props {
  requestClose: () => void;
  deviations: PapiDeviation[];
}

const LazyProgressPopup: React.FC<Props> = props => (
  <ErrorBoundary debugComponent="LazyProgressPopup">
    <Suspense
      fallback={<LoadingIndicator view={'llama'} withOverlay usePortal />}
    >
      <LoadableProgressPopup {...props} />
    </Suspense>
  </ErrorBoundary>
);
LazyProgressPopup.displayName = 'LazyProgressPopup';

export default LazyProgressPopup;
